<script lang="ts">
    import type {UIcons} from 'shared/ui-widgets/uicons/types';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';
    import {exists} from 'shared/utils/custom-utils';

    export let icon: UIcons;
    export let label: string;
    export let value: string | number | null = null;
    export let iconDark = false;
    export let cardBackground: string;
    export let iconBackground: string;
    export let href: string | null = null;

    function getElementProps(isAnchor: boolean): Record<string, any> {
        if (isAnchor) {
            return {href};
        }

        return {type: 'button'};
    }
</script>

<svelte:element this="{exists(href) ? 'a' : 'button'}"
                {...getElementProps(exists(href))}
                role="button"
                tabindex="0"
                class="sutor-landing-icon-card"
                style:--card-bg="{cardBackground}"
                style:--icon-bg="{iconBackground}"
                style:--icon-color="{iconDark ? '#333' : '#FFF'}"
                on:click>

    <div class="icon-label-container">
        <div class="icon-container">
            <UIcon {icon}/>
        </div>

        <span class="card-label">{label}</span>
    </div>

    <div class="value-button-container">
        <span class="card-value">{value ?? ''}</span>

        {#if !exists(href)}
            <div class="go-btn">
                <UIcon icon="angle-small-right"/>
            </div>
        {:else}
            <a {href} class="go-btn">
                <UIcon icon="angle-small-right"/>
            </a>
        {/if}
    </div>
</svelte:element>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .sutor-landing-icon-card {
        width: 100%;
        height: 100%;
        border-radius: @border-radius-xl;
        padding: @spacing-xl;
        display: flex;
        flex-direction: column;
        background-color: var(--card-bg);
        color: #333;
        outline: 2px solid transparent;
        gap: @spacing-l;
        transition: outline-color 0.3s ease-in-out, opacity 0.3s ease-in-out;

        &:hover {
            opacity: 0.75;
            outline-color: var(--accent-blue-new);
            text-decoration: none;
        }

        &:focus,
        &:active {
            text-decoration: none;
        }

        .icon-label-container {
            display: flex;
            align-items: center;
            gap: @spacing-ml;

            .icon-container {
                border-radius: @border-radius-large;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 56px;
                height: 56px;
                font-size: 24px;
                color: var(--icon-color);
                background-color: var(--icon-bg);
            }

            .card-label {
                width: min-content;

                font-size: 18px;
                font-weight: 500;
            }
        }

        .value-button-container {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .card-value {
                font-size: 20px;
                font-weight: 500;
            }

            .go-btn {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 24px;
                height: 24px;
                color: @themed-text-default;
                border-radius: @border-radius-default;
                background-color: @themed-body-bg;
                border: 1px solid @themed-border-default;
                text-decoration: none;
                transition: opacity 0.2s ease-in-out;

                &:hover {
                    text-decoration: none;
                }
            }
        }
    }
</style>